import React, { useState, useEffect } from 'react';
import './ContentNavigationBar.css';

const ContentNavigationBar = ({ 
  content, 
  activeSection, 
  onSectionClick 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(true); // Temporarily always visible for testing
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollY(currentScrollY);
      
      // Show navigation bar when scrolled down more than 50px (reduced threshold)
      setIsVisible(currentScrollY > 50);
    };

    // Check initial scroll position
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMouseEnter = () => {
    console.log('Mouse entered navigation bar');
    setIsExpanded(true);
  };

  const handleMouseLeave = () => {
    console.log('Mouse left navigation bar');
    setIsExpanded(false);
  };
  // Extract headings from content for navigation
  const extractHeadings = (content) => {
    if (!content) return [];
    
    const headingRegex = /^(#{1,6})\s+(.+)$/gm;
    const headings = [];
    let match;
    
    while ((match = headingRegex.exec(content)) !== null) {
      const level = match[1].length;
      const text = match[2].trim();
      const id = text.toLowerCase().replace(/[^a-z0-9]/g, '-');
      
      headings.push({
        id,
        level,
        text,
        active: activeSection === id
      });
    }
    
    return headings;
  };

  const headings = extractHeadings(content);

  // Debug: Always show navigation bar with sample headings if no content
  const debugHeadings = headings.length > 0 ? headings : [
    { id: 'sample-1', level: 1, text: 'Sample Heading 1', active: false },
    { id: 'sample-2', level: 2, text: 'Sample Heading 2', active: false },
    { id: 'sample-3', level: 3, text: 'Sample Heading 3', active: false }
  ];

  // Debug: Log to console
  console.log('ContentNavigationBar rendering:', { isVisible, isExpanded, debugHeadings });
  console.log('Current classes:', `content-navigation-bar ${isVisible ? 'visible' : 'hidden'} ${isExpanded ? 'expanded' : 'collapsed'}`);

  return (
    <div 
      className={`content-navigation-bar ${isVisible ? 'visible' : 'hidden'} ${isExpanded ? 'expanded' : 'collapsed'}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ 
        position: 'fixed', 
        top: '50%', 
        right: '0px', 
        transform: 'translateY(-50%)',
        zIndex: 99999,
        width: '20px',
        height: '200px',
        background: '#6b7280',
        border: '2px solid #374151',
        borderRadius: '6px 0 0 6px',
        boxShadow: '0 0 10px rgba(107, 114, 128, 0.3)'
      }}
    >
      <div className="nav-handle">
        <div className="nav-dots">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>
      
      <div className="nav-content">
        <div className="nav-title">Management Key Focus</div>
        <div className="nav-items">
          {debugHeadings.map((heading) => (
            <div
              key={heading.id}
              className={`nav-item ${heading.active ? 'active' : ''} level-${heading.level}`}
              onClick={() => onSectionClick && onSectionClick(heading.id)}
            >
              {heading.text}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContentNavigationBar;
